<script setup lang="ts">
import FooterInfoCardList from '@/components/Footer/FooterInfoCardList.vue'
import FooterSocialNetworks from '@/components/Footer/FooterSocialNetworks.vue'

import { DownloadCtaButton } from '@features/apps'
import { useResponsive } from '@shared/nuxt/useResponsive'

const { isDesktop } = useResponsive()

const listLinks = [
  {
    text: 'Франшиза',
    url: 'https://farfor.ru/partner/',
    title: 'Открыть франшизу Farfor',
  },
  {
    text: 'Тайный покупатель',
    url: 'https://farfor.ru/control/',
    title: 'Тайный покупатель',
  },
  {
    text: 'Коммерческое предложение',
    url: 'https://farfor.ru/commerce-partnership/',
    title: 'Сотрудничество с Farfor',
  },
  {
    text: 'Новости',
    url: 'https://farfor.ru/news/',
    title: 'Новости',
  },
  {
    text: 'Работа в FARFOR',
    url: 'https://farfor.ru/jobs/',
    title: 'Работа в Farfor',
  },
]

const nuxtLinks = [
  {
    text: 'Политика конфиденциальности',
    url: '/confidential/',
    title: 'Политика конфиденциальности',
  },
  {
    text: 'Пользовательское соглашение',
    url: '/terms_of_use/',
    title: 'Пользовательское соглашение',
  },
]

const nowYear = computed(() => new Date().getFullYear())
</script>

<template>
  <footer class="footer" data-test-id="footer">
    <div class="footer__container-links">
      <div class="footer__links" data-test-id="links-list">
        <a
          v-for="link in listLinks"
          :key="link.url"
          :title="link.title"
          class="footer__link"
          :href="link.url"
          target="_blank"
          data-test-id="external-link"
        >
          {{ link.text }}
        </a>

        <nuxt-link
          v-for="link in nuxtLinks"
          :key="link.url"
          :to="link.url"
          :title="link.title"
          class="footer__link"
          data-test-id="internal-link"
        >
          {{ link.text }}
        </nuxt-link>
      </div>

      <div class="footer__download-button">
        <download-cta-button is-show-full-text />

        <div
          v-if="isDesktop"
          class="footer__download-text"
          data-test="download-text"
        >
          Доступно в AppStore, Google Play, AppGallery
        </div>
      </div>
    </div>

    <div class="footer__container-info">
      <div class="footer__info" data-test-id="copyright">
        © {{ nowYear }}, FARFOR
      </div>

      <footer-info-card-list />

      <footer-social-networks class="footer__social" />
    </div>
  </footer>
</template>

<style scoped lang="scss">
.footer {
  padding: 40px 20px 36px 20px;

  @include media($bp-tablet) {
    padding: 48px 48px 39px 48px;
  }

  @include media($bp-desktop-mini) {
    padding: 40px 0 35px 0;
  }

  &__container-links {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--ui-color-neutral-100);

    @include media($bp-desktop-mini) {
      flex-direction: row;
      align-items: center;
    }
  }

  &__links {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    row-gap: 14px;
    column-gap: 37px;

    @include media($bp-desktop-mini) {
      grid-template-rows: repeat(3, 1fr);
      grid-template-columns: repeat(3, minmax(170px, max-content));
      grid-auto-flow: column;
    }
  }

  &__link {
    font-size: 14px;
    font-weight: 500;
    color: var(--ui-color-neutral-50);
  }

  &__download-text {
    margin-top: 12px;
    font-size: 10px;
    font-weight: 500;
    color: var(--ui-color-neutral-50);
  }

  &__download-button {
    width: 100%;
    margin-bottom: 40px;

    @include media($bp-desktop-mini) {
      width: max-content;
      margin-bottom: 0;
    }
  }

  &__container-info {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-top: 40px;
    color: var(--ui-color-neutral-50);

    @include media($bp-desktop-mini) {
      flex-direction: row;
      gap: 28px;
      align-items: center;
      padding-top: 28px;
    }
  }

  &__info {
    font-size: 10px;
    font-weight: 600;

    * {
      color: var(--ui-color-neutral-50);
    }
  }

  &__social {
    gap: 25px;

    @include media($bp-desktop-mini) {
      margin-left: auto;
    }
  }
}
</style>
